import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { BillingContact } from './response/xero/billing-contact';
import { XeroInvoiceRow } from './response/xero/xero-invoice-row';
import { UpdateBillingContactRequest } from './request/xero/update-billing-contact-request';
import { PropertyBillingSummary } from './response/property-billing-summary';
import { PropertyPricingTierDetails } from './response/PropertyPricingTierDetails';

@Injectable({ providedIn: 'root' })
export class BillingService {
   private base = environment.apiEndpoint;

   constructor(private http: HttpClient) {}

   createXeroContact(propertyId: number, body: any) {
      console.log(body);
      return this.http.post<void>(
         `${this.base}/payment/xero/property/${propertyId}/contact`,
         body,
         { observe: 'response' }
      );
   }

   createRepeatingInvoice(propId: number): Observable<any> {
      return this.http.get(
         `${environment.apiEndpoint}/payment/xero/property/${encodeURIComponent(propId)}/invoice/`
      );
   }

   getBillingContact(propertyId: number) {
      return this.http.get<BillingContact>(
         `${this.base}/payment/property/${propertyId}/billing/contact`
      );
   }

   updateBillingContact(propertyId: number, body: UpdateBillingContactRequest) {
      return this.http.patch<void>(
         `${this.base}/payment/property/${propertyId}/billing/contact`,
         body,
         { observe: 'response' }
      );
   }

   getInvoicesAll(propertyId: number) {
      const params = new HttpParams().set('status', 'all');
      return this.http.get<
         { Paid: XeroInvoiceRow[]; Outstanding: XeroInvoiceRow[] } | XeroInvoiceRow[]
      >(`${this.base}/payment/property/${propertyId}/invoices`, { params });
   }

   getInvoicePdf(invoiceId: string, download = true) {
      const params = new HttpParams()
         .set('pdf', 'true')
         .set('download', download ? 'true' : 'false');

      return this.http.get(`${this.base}/payment/invoices/${invoiceId}`, {
         params,
         responseType: 'blob' as const,
         observe: 'response'
      });
   }

   getPricingTier(propertyId: number) {
      return this.http.get<PropertyPricingTierDetails>(
         `${this.base}/payment/property/${propertyId}/pricing/tier`
      );
   }

   getPropertyBillingSummary(propertyId: number): Observable<PropertyBillingSummary> {
      return this.http.get<PropertyBillingSummary>(
         `${this.base}/payment/property/${propertyId}/billing`
      );
   }

   openBlob(response: any, filename: string) {
      const blob = new Blob([response.body], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
   }
}
